import { ADD_ATTACHMENTS, REMOVE_ATTACHMENTS, REMOVE_FILE } from './constants';

export default function (state = { attachments: [] }, { type, payload }) {
  switch (type) {
    case ADD_ATTACHMENTS:
      return {
        ...state,
        attachments: payload,
      };
    case REMOVE_ATTACHMENTS:
      return {
        attachments: [],
      };
    case REMOVE_FILE:
      return {
        ...state,
        attachments: state.attachments.filter(file => file.name !== payload),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Modules/UploadCashBackFile/UploadComponent/reducer.js